module.exports = __webpack_public_path__ + "img/share.9f80ea5a.png";